import { api } from "./client";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // adjust for production

export const createStockTransfer = async (transferData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/stock-transfer/create`, transferData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Stock transfer failed" };
  }
};


export const getAllStockTransfers = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/stock-transfer/list`, {
      headers: {
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });

    return response.data.transfers;
  } catch (error) {
    console.error("Fetch Stock Transfers Error:", error);
    throw error;
  }
};

export const updateStockTransfer = async (id, payload) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/stock-transfer/${id}`,
      payload,
      {
        headers: {
          "Accept-Language": localStorage.getItem("lang") || "en",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Update Stock Transfer Error:", err);
    throw err;
  }
};

export const deleteStockTransfer = async (id) => {
  const res = await api.delete(`${API_BASE_URL}api/stock-transfer/${id}`);
  return res.data;
};

export const acceptStockTransfer = async (id, payload = {}) => {
  try {
    const response = await api.patch(
      `${API_BASE_URL}api/stock-transfer/${id}/accept`,
      payload,
      {
        headers: {
          "Accept-Language": localStorage.getItem("lang") || "en",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Accept Stock Transfer Error:", err);
    throw err;
  }
};

export const rejectStockTransfer = async (id, payload = {}) => {
  try {
    const response = await api.patch(
      `${API_BASE_URL}api/stock-transfer/${id}/reject`,
      payload,
      {
        headers: {
          "Accept-Language": localStorage.getItem("lang") || "en",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Reject Stock Transfer Error:", err);
    throw err;
  }
};
